const MENU_TO_ALLOW_IF_PAM_ENABLED = ['assets-sessions', 'privileged-service-account-management'];
const MENU_TO_ALLOW_IF_PAM_DISABLED = [
  'new-privileged-access',
  'privileged-sessions',
  'past-sessions',
  'privileged-service-account-management',
];
const ALL_MENUS_TO_DISALLOW_IF_JFA_ENABLED = [
  ...new Set(MENU_TO_ALLOW_IF_PAM_ENABLED.concat(MENU_TO_ALLOW_IF_PAM_DISABLED)),
];

/**
 * A util function to filter out the Unified Nav Bar based on feature flag enablement
 *
 * @function
 *
 * @param subMenuItem {String} key/id for a submenu item listing of a nav submenu
 * @param featureFlags {Object} an object for reading customer feature flags booleans
 */
export const filterUnifiedNavSubmenuView = (subMenuItem, featureFlags) => {
  const { isPamGen2, isJitForApps, isEmergencyRolesUser } = featureFlags;
  if (subMenuItem.id === 'privileged-access') {
    if (isJitForApps && isPamGen2) {
      subMenuItem.link = '/request/privilegedAccess';
      subMenuItem.subMenu = subMenuItem.subMenu.filter(
        (ele) => !ALL_MENUS_TO_DISALLOW_IF_JFA_ENABLED.includes(ele.id)
      );
    } else {
      const allowedIds = isPamGen2 ? MENU_TO_ALLOW_IF_PAM_ENABLED : MENU_TO_ALLOW_IF_PAM_DISABLED;
      subMenuItem.subMenu = subMenuItem.subMenu.filter((ele) => allowedIds.includes(ele.id));
    }
  }

  if (subMenuItem.id === 'emergency-access') {
    if (!isEmergencyRolesUser) {
      subMenuItem.subMenu = subMenuItem.subMenu.filter(
        (ele) => ele.id !== 'request-emergency-access-roles'
      );
    }
  }
};
